import {
    LOADING_TOGGLE_ACTION,
    KYC_SETTING_LIST_INITIATED,
    KYC_SETTING_INITIATED,
    KYC_SETTING_LIST_LOADED,
    KYC_SETTING_LOADED,
    KYC_SETTING_FAILED,
    KYC_SETTING_CREATED,
    KYC_SETTING_UPDATED,
    KYC_SETTING_DELETED,
    CLEAR_CURRENT_KYC_SETTING,
    CLEAR_ERRORS,
    SET_CURRENT_PAGE,
    SET_FILTERS
} from '../actions/KycMasterActions';

const initialState = {
    kycSettings: [],
    currentKycSetting: null,
    loading: false,
    listLoading: false,
    error: null,
    pagination: {
        totalRecords: 0,
        totalPages: 0,
        currentPage: 1,
        pageSize: 10,
        hasNext: false,
        hasPrevious: false
    },
    filters: {
        search: '',
        status: '',
        kycType: '',
        documentType: '',
        isRequired: ''
    }
};

export function KycMasterReducer(state = initialState, action) {
    switch (action.type) {
        case LOADING_TOGGLE_ACTION:
            return {
                ...state,
                loading: action.payload,
            };

        case KYC_SETTING_LIST_INITIATED:
            return {
                ...state,
                listLoading: true,
                error: null
            };

        case KYC_SETTING_INITIATED:
            return {
                ...state,
                loading: true,
                error: null
            };

        case KYC_SETTING_LIST_LOADED:
            return {
                ...state,
                kycSettings: action.payload.data || [],
                pagination: action.payload.pagination || state.pagination,
                listLoading: false,
                error: null
            };

        case KYC_SETTING_LOADED:
            return {
                ...state,
                currentKycSetting: action.payload,
                loading: false,
                error: null
            };

        case KYC_SETTING_FAILED:
            return {
                ...state,
                loading: false,
                listLoading: false,
                error: action.payload
            };

        case KYC_SETTING_CREATED:
            return {
                ...state,
                kycSettings: [...state.kycSettings],
                currentKycSetting: action.payload,
                loading: false,
                error: null
            };

        case KYC_SETTING_UPDATED:
            return {
                ...state,
                kycSettings: state.kycSettings.map(item =>
                    item.id === action.payload.id ? action.payload : item
                ),
                currentKycSetting: action.payload,
                loading: false,
                error: null
            };

        case KYC_SETTING_DELETED:
            return {
                ...state,
                kycSettings: state.kycSettings.filter(item =>
                    item.id !== action.payload
                ),
                loading: false,
                error: null
            };

        case CLEAR_CURRENT_KYC_SETTING:
            return {
                ...state,
                currentKycSetting: null,
                error: null
            };

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null
            };

        case SET_CURRENT_PAGE:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    currentPage: action.payload
                }
            };

        case SET_FILTERS:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload
                }
            };

        default:
            return state;
    }
}